import styled from 'styled-components';

export const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const StyledTableContainer = styled.div`
  border: 2px solid rgb(238, 238, 238);
  overflow-x: scroll;
  width: 100%;
  position: relative;
  min-height: 600px;
  max-height: 600px;
  overflow-y: auto;
`;

export const StyledTable = styled.table<{ width: number }>`
  border-collapse: separate;
  border-spacing: 0;
  text-align: center;
  width: ${({ width }): number => width}px;
`;

export const StyledTh = styled.th<{
  boxShadow: string | undefined;
  left: string | undefined;
  position: string;
  zIndex: number;
  width: number;
  height: number;
}>`
  max-width: ${({ width }): number => width}px;
  position: ${({ position }): string => position};
  z-index: ${({ zIndex }): number => zIndex};
  left: ${({ left }): string | undefined => left};
  box-shadow: ${({ boxShadow }): string | undefined => boxShadow};
  background-color: #ffffff;
  border: 1px solid rgb(238, 238, 238);
  font-weight: bold;
  padding: 6px 6px;
  text-align: center;
  height: ${({ height }): number => height}px;
`;

export const StyledInnerTh = styled.div<{ cursor?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: ${({ cursor }): string | undefined => (cursor ? cursor : 'default')};
`;

export const StyledTd = styled.td<{
  boxShadow: string | undefined;
  left: string | undefined;
  position: string;
  zIndex: number;
  width: number;
}>`
  border: 1px solid rgb(238, 238, 238);
  padding: 2px 4px;
  text-align: center;
  width: ${({ width }): number => width};
  position: ${({ position }): string => position};
  z-index: ${({ zIndex }): number => zIndex};
  left: ${({ left }): string | undefined => left};
  box-shadow: ${({ boxShadow }): string | undefined => boxShadow};
`;

export const StyledInnerTd = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SearchInput = styled.input`
  width: 100%;
  text-align: center;
  border: 1px solid lightgrey;
  height: 40px;
  border-radius: 2px;
`;

export const StyledTr = styled.tr<{ odd: boolean }>`
  height: 40px;
  td {
    height: 40px;
    background-color: ${(props): string => {
      return props.odd ? '#ffffff' : '#f2f2f2';
    }};
  }
`;

export const StyledThead = styled.thead`
  position: sticky;
  top: 0;
  z-index: 2;
`;
